import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../data/content";

export default function FaqSection() {
  return (
    <section className="py-24 lg:py-36 border-t border-white/5" data-testid="faq-section">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4">
            <p className="section-label">FAQ</p>
            <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white">
              STRAIGHT <span className="text-flame">ANSWERS.</span>
            </h2>
            <p className="mt-6 text-slate-400 text-sm leading-relaxed">
              Everything businesses usually ask before starting a build. Something missing? Ask us on WhatsApp.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-white/10">
                  <AccordionTrigger
                    data-testid={`faq-q-${i}`}
                    className="text-left font-heading font-semibold text-slate-100 hover:text-flame hover:no-underline py-5"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-slate-400 leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
